import {ScanPosition, ScanTypes, SpinalLocation, ValidSpinalLocation} from "./weak-entities";
import {ScanProtocolSettings} from "./practice";

export class ScanSettings {
  public ScanType: ScanTypes;
  public EnableCalibration: boolean;
  public ScanPurpose: ScanPurpose;
  public StartingLocation: SpinalLocation;
  public BodyType: BodyTypes;
  public Sounds: string;
}

export enum BodyTypes {
  Adult,
  Child,
  Infant
}

export enum ScanPurpose {
  Initial,
  Comparative,
  Pre,
  Post,
  Quick,
}

export function getPurposeName(purpose: ScanPurpose) {
  switch (purpose) {
    case ScanPurpose.Post:
      return 'Post Adjustment';
    case ScanPurpose.Pre:
      return 'Pre Adjustment';
    case ScanPurpose.Comparative:
      return 'Comparative Exam';
    case ScanPurpose.Initial:
      return 'Initial Exam';
    case ScanPurpose.Quick:
      return 'Quick Scan'

  }
}

export class CalibrationCompleteResults {
  public match?: boolean;
  public right: number;
  public left: number;
  public data: any;
}

export enum ThermalScanMethod {
  Rolling,
  Segmental
}
export class ThermalSettings extends ScanSettings {
  public ScanMethod: ThermalScanMethod;
  public StartingLocation: SpinalLocation;
  public Protocol: ScanProtocolSettings;
  public SkipCheckpoints: boolean;
}
export class EmgSettings extends ScanSettings {
  public Protocol: ScanProtocolSettings;
  public Position: ScanPosition;
  public DefaultScale: number;
}
export class HrvSettings extends ScanSettings {
  public RestingDuration: number = 10;
  public ScanDuration: number = 180;
  public EarClip: boolean = false;
}

export class ThermalData {
  public leftHardwareOffset: number;
  public leftHardwareGain: number;
  public rightHardwareGain: number;
  public centerhardwareOffset: number;
  public switchState: number;
  public position: number;
  public trigger: boolean;
  public leftTemp: number;
  public leftRawTemp: number;
  public rightTemp: number;
  public rightRawTemp: number;
  public diffTemp: number;
  public distance: number;
  public location: number;
}



// WEBPACK FOOTER //
// ./src/model/scanSettings.ts